import './Donate.css'
import danny from '../../assets/images/danny.JPG'
import ButtonLink from '../Buttonlink/Buttonlink';

function Donate() {
  return (
    <>
    <div className='new-page'>
      <div>
        <h3>Thank you for your donation.</h3>
      </div>
      <div>
        <ButtonLink text="Home" href="/" />
      </div>
      <div>
        <p>A payment to <b>12INCHTAILS</b> will show up on your statement. </p>
        <p><b>Tax ID:</b>92-3227490</p>
        <p>
          If you have any questions, please email <b>12inchtails@gmail.com</b>
        </p>
        <img src={danny} alt="Danny" />
      </div>
    </div>
    </>
  )
}

export default Donate;